import { reactive, ref } from "vue";

export function useHonninNotesInputModal() {
  const honninNotesInputModalRef = ref()

  const honninNotesInputModalParts = reactive({
    title: '備考の入力',
    button: ''
  })

  const openHonninNotesInputModal = () => {
    honninNotesInputModalRef.value.open()
  }

  const closeHonninNotesInputModal = () => {
    honninNotesInputModalRef.value.close()
  }

  return {
    honninNotesInputModalRef,
    honninNotesInputModalParts,
    openHonninNotesInputModal,
    closeHonninNotesInputModal,
  }
}
